export default {
    primary: '#94C127',
    secondary: '#1B9BD8',
    error: '#E51F1F',
    info: '#212121', // is used in showroom only
    warning: '#FFC107',
    scrollbar: '#F9C40C',
    'label-text': '#ffffff',
    'on-secondary': '#ffffff',
    'on-warning': '#ffffff',
    'on-error': '#ffffff'
};
